import customHeaders, { getSpace } from '../../../common/headers';
import Cookies from 'universal-cookie';
import { useEffect, useRef, useState, useCallback } from 'react';
import { CommentItem } from '../../../components/CommentItem/CommentItem';
import { Comment } from '../../../components/Comment/Comment';
import { MoonLoader } from 'react-spinners';
import useGeneralStore from '../../../store/general';
import InfiniteScroll from "react-infinite-scroll-component";
import { SceletonChat } from '../../ChatMessage/SceletonChat/SceletonChat';
import { TabsGreyBtn } from '../../../components/TabsGreyBtn/TabsGreyBtn';

const btns = [
    {
        label: 'Чаты',
        value: 'Все'
    },
    {
        label: 'Группы',
        value: 'Группы'
    }
]

const btns_2 = [
    {
        label: 'Все',
        value: 'all'
    },
    {
        label: 'Закрепленные',
        value: 'pin'
    },
    {
        label: 'Избранные',
        value: 'favorite'
    }
]

const ChatComment = ({
    chatId,
    authorId
}) => {

    const selectedSpace = useGeneralStore(state => state.selectedSpace)
    const headers = { ...customHeaders, ...getSpace(selectedSpace) }

    const cookie = new Cookies()
    const auth = cookie.get('auth')
    const bottomRef = useRef()

    // Информация о юзере
    const email = localStorage.getItem('email');
    const currentUserColor = localStorage.getItem('currentUserColor');
    const currentUserName = localStorage.getItem('currentUserName');

    const [answerValue, setAnswerValue] = useState('')

    // Новые состояния для отслеживания соединения WebSocket
    const [isWebSocketConnected, setIsWebSocketConnected] = useState(false);
    const [connectionStatus, setConnectionStatus] = useState('disconnected'); // 'disconnected', 'connecting', 'connected', 'error'

    const [isModalCreateGroup, setIsModalCreateGroup] = useState(false)
    const [messageItems, setMessageItems] = useState([])

    const [chatList, setChatList] = useState([])

    const [status, setStatus] = useState(btns?.[0]?.value)
    const [status2, setStatus2] = useState(btns_2?.[0]?.value)
    const [currentProject, setCurrentProject] = useState(-1)
    const [currentMessage, setCurrentMessage] = useState({})
    const socket = useRef()

    const [saveFileMessage, setSaveFileMessage] = useState([]);
    const [saveFileComment, setSaveFileComment] = useState([]);
    const [currentMessageAnswer, setCurrentMessageAnswer] = useState(null);

    const [favoritePage, setFavoritePage] = useState(1);

    const [pinMessage, setPinMessage] = useState([])
    const [favoriteMessage, setFavoriteMessage] = useState([])

    const [loadingMessage, setLoadingMessage] = useState(false)
    const [loadingMessageItem, setLoadingMessageItem] = useState(false)

    const [search, setSearch] = useState('')
    const [totalMessage, setTotalMessage] = useState(true)
    const [tokenAuth, setTokenAuth] = useState(null)

    // Новые состояния для плашки "Новые сообщения"
    const [lastUnreadMessageId, setLastUnreadMessageId] = useState(null)
    const [initialLastUnreadMessageId, setInitialLastUnreadMessageId] = useState(null)
    const [showNewMessagesAlert, setShowNewMessagesAlert] = useState(false)
    const scrollContainerRef = useRef()
    const newMessageAlertRef = useRef(null)
    const [hasScrolledToAlert, setHasScrolledToAlert] = useState(false)
    const [isInitialLoad, setIsInitialLoad] = useState(true)

    // Состояние для отслеживания наличия более старых сообщений (для лоадера при скролле вверх)
    const [hasMore, setHasMore] = useState(true)

    // Функция проверки готовности WebSocket соединения
    const isSocketReady = () => {
        return socket.current &&
            socket.current.readyState === WebSocket.OPEN &&
            isWebSocketConnected;
    }

    const onScroll = (listRef, setPageHeight, setScrollTop) => {
        const { scrollTop, scrollHeight, clientHeight } = listRef.current;
        const topHeight = scrollTop;
        if (topHeight === 0) {
            setPageHeight(scrollHeight);
        }
        setScrollTop(scrollTop);
    };

    const curren_massage_list = () => {
        if (status2 == 'pin') return pinMessage
        if (status2 == 'favorite') return favoriteMessage
        return messageItems
    }

    // Функция для нахождения ID последнего непрочитанного сообщения при первом открытии
    const findLastUnreadMessageId = () => {
        const messages = curren_massage_list();
        for (let i = messages.length - 1; i >= 0; i--) {
            const message = messages[i];
            if (message?.is_read === false && message?.author?.id !== authorId) {
                return message?.message_id;
            }
        }
        return null;
    }

    // Функция для прокрутки к плашке новых сообщений
    const scrollToNewMessagesAlert = useCallback(() => {
        if (newMessageAlertRef.current && scrollContainerRef.current && !hasScrolledToAlert) {
            // Используем requestAnimationFrame для синхронизации с рендерингом
            requestAnimationFrame(() => {
                // Небольшая задержка для гарантии, что DOM обновился
                setTimeout(() => {
                    const alertElement = newMessageAlertRef.current;
                    const container = scrollContainerRef.current;
                    
                    if (alertElement && container) {
                        // Вычисляем позицию элемента
                        const alertRect = alertElement.getBoundingClientRect();
                        const containerRect = container.getBoundingClientRect();
                        
                        // Прокручиваем так, чтобы плашка была в центре видимой области
                        const alertOffset = alertRect.top - containerRect.top + container.scrollTop;
                        const targetScroll = alertOffset - (containerRect.height / 2) + (alertRect.height / 2);
                        
                        container.scrollTop = targetScroll;
                        setHasScrolledToAlert(true);
                    }
                }, 0);
            });
        }
    }, [hasScrolledToAlert]);

    // Эффект для скролла при первом рендере сообщений
    useEffect(() => {
        if (status2 === 'all' && curren_massage_list().length > 0 && isInitialLoad) {
            const lastUnreadId = findLastUnreadMessageId();
            if (lastUnreadId) {
                setInitialLastUnreadMessageId(lastUnreadId);
                setLastUnreadMessageId(lastUnreadId);
                setShowNewMessagesAlert(true);
                
                // После установки состояния, ждем следующего рендера для прокрутки
                setIsInitialLoad(false);
            }
        }
    }, [curren_massage_list(), status2, authorId, isInitialLoad]);

    // Эффект для скролла после обновления DOM
    useEffect(() => {
        if (showNewMessagesAlert && lastUnreadMessageId && !hasScrolledToAlert && curren_massage_list().length > 0) {
            // Проверяем, есть ли элемент в DOM
            const timer = setTimeout(() => {
                scrollToNewMessagesAlert();
            }, 100);
            
            return () => clearTimeout(timer);
        }
    }, [showNewMessagesAlert, lastUnreadMessageId, hasScrolledToAlert, curren_massage_list(), scrollToNewMessagesAlert]);

    // Сбрасываем флаг скролла при смене чата или таба
    useEffect(() => {
        setHasScrolledToAlert(false);
        setIsInitialLoad(true);
        setHasMore(true); // Сбрасываем hasMore при смене чата или таба
    }, [chatId, status2]);

    // Обновляем lastUnreadMessageId при изменении сообщений
    useEffect(() => {
        if (status2 === 'all' && curren_massage_list().length > 0 && initialLastUnreadMessageId) {
            // Проверяем, существует ли еще начальное последнее непрочитанное сообщение
            const messageExists = curren_massage_list().some(msg => msg?.message_id === initialLastUnreadMessageId);
            if (messageExists) {
                setLastUnreadMessageId(initialLastUnreadMessageId);
                setShowNewMessagesAlert(true);
            } else {
                // Если начальное сообщение было удалено или прочитано, находим новое последнее непрочитанное
                const newLastUnreadId = findLastUnreadMessageId();
                if (newLastUnreadId) {
                    setLastUnreadMessageId(newLastUnreadId);
                    setShowNewMessagesAlert(true);
                    // Если нашли новое непрочитанное сообщение, разрешаем скролл к нему
                    setHasScrolledToAlert(false);
                } else {
                    setShowNewMessagesAlert(false);
                }
            }
        }
    }, [curren_massage_list(), status2, authorId, initialLastUnreadMessageId]);

    const updateScroll = () => {
        // существующий код
    }

    useEffect(() => {
        if (favoritePage > 1) {
            fetchGetFavorite();
        }
    }, [favoritePage]);

    useEffect(() => {
        setTotalMessage(true)
        setHasMore(true) // Сбрасываем hasMore при загрузке новой вкладки
        if (status2 == 'pin') fetchGetPinned()
        if (status2 == 'favorite') fetchGetFavorite()
        if (status2 == 'all') fetchGetMessageHistory()
    }, [status2, currentMessage]);

    const onSendMessage = (comment) => {
        // Проверка состояния соединения WebSocket
        if (!isSocketReady()) {
            console.error('WebSocket соединение не установлено или закрыто');
            return;
        }

        // // Проверка на пустое сообщение
        // if (!comment || comment.trim() === '') {
        //     return;
        // }

        try {
            socket.current.send(JSON.stringify({
                current_user: authorId,
                message_text: comment,
                parent_message_id: currentMessageAnswer?.id || null,
                files: saveFileMessage
            }));
            setAnswerValue('');
        } catch (error) {
            console.error('Ошибка при отправке сообщения через WebSocket:', error);
            alert('Ошибка отправки сообщения. Проверьте соединение с сервером.');
        }
    }

    useEffect(() => {
        fetchGetToken()
    }, [chatId]);

    useEffect(() => {
        if(!tokenAuth) return
        if (chatId) {

            // Функция для закрытия соединения
            const closeSocket = () => {
                if (socket.current && typeof socket.current.close === 'function') {
                    console.log('Closing previous connection');
                    socket.current.close(1000, 'Closing for new connection');
                }
            };

            // Функция для очистки состояния
            const cleanup = () => {
                setMessageItems([]);
                setLoadingMessage(false);
            };

            if (chatId) {
                // Очищаем предыдущее состояние и закрываем соединение
                setTotalMessage(true)
                cleanup();
                closeSocket();

                // Сбрасываем плашку только при новом чате
                if (chatId !== currentMessage?.chat_id) {
                    setInitialLastUnreadMessageId(null);
                    setLastUnreadMessageId(null);
                    setShowNewMessagesAlert(false);
                }

                if (chatId) {
                    try {
                        socket.current = new WebSocket(
                            `wss://apps0.ecomru.ru:4454/ws/chat_id/${chatId}?authorization=${tokenAuth}&space_id=${selectedSpace?.value}`
                        );
                        setLoadingMessage(true);
                        setConnectionStatus('connecting');
                        setIsWebSocketConnected(false);

                        socket.current.onopen = () => {
                            console.log('WebSocket соединение установлено');
                            setConnectionStatus('connected');
                            setIsWebSocketConnected(true);
                        };

                        socket.current.onclose = (e) => {
                            console.log(`Соединение закрыто: ${e.code} - ${e.reason}`);
                            setConnectionStatus('disconnected');
                            setIsWebSocketConnected(false);
                        };

                        socket.current.onerror = (error) => {
                            console.log(`WebSocket ошибка: ${error.message}`);
                            setConnectionStatus('error');
                            setIsWebSocketConnected(false);
                            cleanup();
                        };
                    } catch (error) {
                        console.error('WebSocket error:', error);
                        setConnectionStatus('error');
                        setIsWebSocketConnected(false);
                        cleanup();
                    }
                }
            }

            // Функция очистки при размонтировании или изменении зависимостей
            return () => {
                closeSocket();
                cleanup();
            };
        }
    }, [tokenAuth]);

useEffect(() => {
    if (socket.current) {
        socket.current.onmessage = (e) => {
            const data = JSON.parse(e.data);
            const { messages, total, signal } = data;

            if (data?.messages) {
                if (total > messages?.length) {
                    setTotalMessage(true)
                    setHasMore(true) // Есть еще сообщения для загрузки
                } else {
                    setTotalMessage(false)
                    setHasMore(false) // Больше нет сообщений для загрузки
                }

                if (status2 === 'pin') {
                    setPinMessage((prev) => [...prev, ...messages]);
                } else if (status2 === 'favorite') {
                    setFavoriteMessage((prev) => [...prev, ...messages]);
                } else {
                    setMessageItems((prev) => [...prev, ...messages]);
                }
            }

            // Удаление сообщения
            if (data?.signal) {
                if (signal?.type == 'delete') {
                    console.log('удаление')
                    const messageIdToDelete = signal?.current_message_id;

                    if (status2 === 'pin') {
                        setPinMessage(prev => prev.filter(message => message.message_id !== messageIdToDelete));
                    } else if (status2 === 'favorite') {
                        setFavoriteMessage(prev => prev.filter(message => message.message_id !== messageIdToDelete));
                    } else {
                        setMessageItems(prev => prev.filter(message => message.message_id !== messageIdToDelete));
                    }
                }
            }

            // Удаление из избранного и открепить
            if (data?.signal) {
                if (signal?.type == 'del_favourite') {
                    const messageIdToDelete = signal?.current_message_id;

                    if (status2 === 'favorite') {
                        setFavoriteMessage(prev => prev.filter(message => message.message_id !== messageIdToDelete));
                    }
                }
            }

            // Удаление из избранного и открепить
            if (data?.signal) {
                if (signal?.type == 'del_pinned') {
                    const messageIdToDelete = signal?.current_message_id;

                    if (status2 === 'pin') {
                        setPinMessage(prev => prev.filter(message => message.message_id !== messageIdToDelete));
                    }
                }
            }

            // Обработка change_status отдельно (новый формат с массивом сообщений)
            if (data?.signal) {
                if (signal?.type == 'change_status') {
                    const updatedMessages = signal?.message; // Это массив сообщений
                    
                    if (Array.isArray(updatedMessages)) {
                        // Создаем Map для быстрого поиска обновленных сообщений
                        const updatedMessagesMap = new Map();
                        updatedMessages.forEach(msg => {
                            if (msg?.message_id) {
                                updatedMessagesMap.set(msg.message_id, msg);
                            }
                        });
                        
                        // Функция для обновления состояния
                        const updateState = (prevState) => {
                            return prevState.map(message => {
                                const updatedMsg = updatedMessagesMap.get(message?.message_id);
                                return updatedMsg || message;
                            });
                        };
                        
                        if (status2 === 'pin') {
                            setPinMessage(prev => updateState(prev));
                        } else if (status2 === 'favorite') {
                            setFavoriteMessage(prev => updateState(prev));
                        } else {
                            setMessageItems(prev => updateState(prev));
                        }
                    }
                    
                    setLoadingMessage(false);
                    return; // Выходим, чтобы не выполнять код ниже
                }
            }

            // Обновление сообщения (для остальных сигналов)
            if (data?.signal) {
                if (signal?.type == 'update' ||
                    signal?.type == 'add_favourite' ||
                    signal?.type == 'del_favourite' ||
                    signal?.type == 'add_pinned' ||
                    signal?.type == 'del_pinned'
                ) {
                    const messageIdToDelete = signal?.current_message_id;

                    if (status2 === 'pin') {
                        setPinMessage(prev => prev.map(message => {
                            if (message.message_id == messageIdToDelete) {
                                return signal?.message ? signal?.message : message
                            } else {
                                return message
                            }
                        }));
                    } else if (status2 === 'favorite') {
                        setFavoriteMessage(prev => prev.map(message => {
                            if (message.message_id == messageIdToDelete) {
                                return signal?.message ? signal?.message : message
                            } else {
                                return message
                            }
                        }));
                    } else {
                        setMessageItems(prev => prev.map(message => {
                            console.log(message.message_id, messageIdToDelete)
                            if (message?.message_id == messageIdToDelete) {
                                return signal?.message ? signal?.message : message
                            } else {
                                return message
                            }
                        }));
                    }
                }
            }

            if (data?.message_id) {
                setMessageItems((prev) => [data, ...prev]);
            }

            setLoadingMessage(false);
        };
    }
}, [status2, socket.current]);


    // Токен для подключения WS
    const fetchGetToken = (chat_id, client_ids) => {
        if (chatId) {
            let url = `https://apps0.ecomru.ru:4454/ws/auth?chat_id=${chatId}`

            fetch(url, { method: 'POST', headers })
                .then(res => {
                    if (res.ok) {
                        return res.json()
                    } else {
                        throw new Error('bad resp')
                    }
                })
                .then(json => {
                    if (json?.key) {
                        setTokenAuth(json?.key)
                    }
                })
                .catch(err => console.error(err))
        }
    }

    // Получить историю сообщений
    const fetchGetMessageHistory = (abortController = new AbortController(), message_id) => {
        if (socket.current && socket.current.readyState === WebSocket.OPEN) {
            if (curren_massage_list().length > 0) {
                setLoadingMessageItem(true)
            } else setLoadingMessage(true)

            socket?.current?.send(JSON.stringify({
                type: 'get_history',
                early_message_id: message_id,
                limit: 10,
                chat_id: chatId
            }))
            setLoadingMessageItem(false)
            setLoadingMessage(false)
        }
    }

    // Добавить сообщение в закреп
    const fetchPinMessage = (type, id, message, early_message_id) => {
        socket.current.send(JSON.stringify({
            type: type,
            early_message_id: null,
            current_message_id: id,
            chat_id: message?.chat_id,
            message
        }))
    }

    // Получить закрепленые сообщения
    const fetchGetPinned = (abortController = new AbortController(), message_id = null) => {
        if (curren_massage_list().length > 0) {
            setLoadingMessageItem(true)
        } else setLoadingMessage(true)

        socket.current.send(JSON.stringify({
            type: 'get_pinned',
            early_message_id: message_id,
            limit: 10,
            chat_id: chatId
        }))
        setLoadingMessageItem(false)
        setLoadingMessage(false)
    }

    // Получить избранные сообщения
    const fetchGetFavorite = (abortController = new AbortController(), message_id = null) => {
        if (curren_massage_list().length > 0) {
            setLoadingMessageItem(true)
        } else setLoadingMessage(true)

        socket.current.send(JSON.stringify({
            type: 'get_favourite',
            early_message_id: message_id,
            limit: 10,
            chat_id: chatId
        }))
        setLoadingMessageItem(false)
        setLoadingMessage(false)
    }

    // Добавить в избранное
    const fetchFavorite = (type, id, message, early_message_id) => {
        socket.current.send(JSON.stringify({
            type: type,
            early_message_id: null,
            current_message_id: id,
            chat_id: message?.chat_id,
            message
        }))
    }

    // Редактировать сообщение
    const fetchChangeMessage = (id, text, files = [], early_message_id, message) => {
        socket.current.send(JSON.stringify({
            type: 'update',
            early_message_id,
            current_message_id: id,
            chat_id: chatId,
            message: {
                ...message,
                text: text,
                files: [...files, ...saveFileComment],
            }
        }))
    }

    // Сменить статус сообщения
    const fetchChangeStatus = (id, early_message_id, message) => {
        socket.current.send(JSON.stringify({
            type: 'change_status',
            early_message_id,
            // current_message_id: id,
            chat_id: chatId,
            choice_message: "CHOICE", // "ALL"
            message_id: [message?.message_id]
        }))
    }

    // Удалить сообщение
    const fetchDeleteMessage = (id, early_message_id, message) => {
        socket.current.send(JSON.stringify({
            type: 'delete',
            early_message_id,
            current_message_id: id,
            chat_id: message?.chat_id,
            message
        }))
    }

    // Удалить файл
    const fetchDeleteFiles = (message_id, _url, message, early_message_id) => {
        const current_list_files = message?.files.filter((elem) => {
            return elem?.url !== _url
        })

        socket.current.send(JSON.stringify({
            type: 'update',
            early_message_id,
            current_message_id: message_id,
            chat_id: chatId,
            message: {
                ...message,
                files: current_list_files,
            }
        }))
    }

    const getUnreadCount = async () => {
        setIsModalCreateGroup(false)
        let url = `https://apps1.ecomru.ru:4444/project/${currentProject?.project_id}/chat/${currentMessage?.chat_id}/message/unread`

        const res = await fetch(url, { method: 'GET', headers })
            .then(res => {
                if (res.ok) {
                    return res.json()
                } else {
                    throw new Error('bad resp')
                }
            })
            .then(({ unread_messages }) => {
                return unread_messages
            })
            .catch(err => console.error(err))
        return res
    }

    const updateUnreadCount = () => {
        const count = getUnreadCount()
        const chat_id = currentMessage?.chat_id ? currentMessage?.chat_id : currentMessage?.id ? currentMessage?.id : -1
        setChatList(prev => prev?.map(el => el?.chat_id === chat_id ? { ...el, unread_messages_count: count } : el))
    }

    function Position(obj) {
        var currenttop = 0;
        if (obj.offsetParent) {
            do {
                currenttop += obj.offsetTop;
            } while ((obj = obj.offsetParent));
            return [currenttop];
        }
    }

    useEffect(() => {
        const abortController = new AbortController();
        setCurrentMessage(null)
        // Сбрасываем состояния скролла
        setHasScrolledToAlert(false);
        setIsInitialLoad(true);
        setInitialLastUnreadMessageId(null);
        setLastUnreadMessageId(null);
        setShowNewMessagesAlert(false);
        setHasMore(true); // Сбрасываем hasMore

        return () => abortController.abort();
    }, [currentProject, status, selectedSpace, search])

    const resetMessages = () => {
        setTotalMessage(true)
        setCurrentMessageAnswer(null)
    }

    useEffect(() => {
        resetMessages()
    }, [currentMessage]);

    return (
        <div className='chat_message_page__content_message_send'>
            <TabsGreyBtn
                btns={btns_2}
                currentBtn={status2}
                setCurrentBtn={(e) => {
                    if (chatId) {
                        setStatus2(e)
                        setPinMessage([])
                        setFavoriteMessage([])
                        setMessageItems([])
                        // Сбрасываем плашку и состояние скролла при смене таба
                        setHasScrolledToAlert(false);
                        setIsInitialLoad(true);
                        setInitialLastUnreadMessageId(null);
                        setLastUnreadMessageId(null);
                        setShowNewMessagesAlert(false);
                        setHasMore(true); // Сбрасываем hasMore при смене таба
                    }
                }}
                checkValue={true}
            />

            <div className='chat_message_page__content_message'
                ref={scrollContainerRef}
                id="scrollableDiv"
                style={{
                    flexDirection: 'column-reverse',
                    overflowY: 'auto',
                    position: 'relative'
                }}
            >
                {(loadingMessage) ?
                    <SceletonChat />
                    :
                    curren_massage_list()?.length < 1 ?
                        <div
                            className='text_grey'
                            style={{ margin: '0 auto', height: '100%', display: 'flex', alignItems: 'center', fontSize: 14 }}
                        >
                            В этом чате еще нет сообщений
                        </div>
                        :
                        <InfiniteScroll
                            scrollableTarget="scrollableDiv"
                            dataLength={curren_massage_list()?.length}
                            next={(e) => {
                                if (!loadingMessage && !loadingMessageItem && hasMore) {
                                    setTotalMessage(true)
                                    if (status2 == 'pin') fetchGetPinned([], curren_massage_list()?.at(-1)?.message_id)
                                    if (status2 == 'favorite') fetchGetFavorite([], curren_massage_list()?.at(-1)?.message_id)
                                    if (status2 == 'all') fetchGetMessageHistory([], curren_massage_list()?.at(-1)?.message_id)
                                }
                            }}
                            inverse={true}
                            hasMore={hasMore}
                            loader={
                                <div className='chat_message_page__load-item' style={{ margin: '10px 0' }}>
                                    <MoonLoader
                                        size='40'
                                        color="#7b7b7b"
                                        speedMultiplier={0.5}
                                    />
                                </div>
                            }
                            style={{ display: 'flex', flexDirection: 'column-reverse' }}
                            initialScrollY={0} // Начинаем с верха
                        >

                            <>
                                {(curren_massage_list()?.map((item, ind) => {
                                    const {
                                        created_at,
                                        text,
                                        author,
                                        files,
                                        message_id,
                                        is_read,
                                        is_seen,
                                        parent_message,
                                        isAuthor,
                                        is_favourite,
                                        is_pinned
                                    } = item || {};

                                    // Вставляем плашку "Новые сообщения" перед последним непрочитанным сообщением
                                    const shouldShowAlert = showNewMessagesAlert && 
                                                           status2 === 'all' && 
                                                           lastUnreadMessageId === message_id;

                                    return (
                                        <div key={`wrapper-${message_id}`}>
                                            {shouldShowAlert && (
                                                <div 
                                                    className='chat_message_page__new-message'
                                                    ref={newMessageAlertRef}
                                                >
                                                    Новые сообщения
                                                </div>
                                            )}
                                            <CommentItem
                                                key={message_id + files?.length + text + is_favourite + is_pinned}
                                                early_message_id={curren_massage_list?.[ind - 1]?.message_id}
                                                id={message_id}
                                                fetchDelete={fetchDeleteMessage}
                                                fetchChange={fetchChangeMessage}
                                                saveFileComment={saveFileComment}
                                                setSaveFileComment={setSaveFileComment}
                                                saveFile={saveFileComment}
                                                setSaveFile={setSaveFileComment}
                                                files={files}
                                                date={created_at}
                                                text={text}
                                                author={author}
                                                chat_id={currentMessage?.chat_id}
                                                project_id={currentProject?.project_id}
                                                updateUnreadCount={e => updateUnreadCount()}
                                                fetchChangeStatus={fetchChangeStatus}
                                                fetchPinComment={fetchPinMessage}
                                                fetchFavorite={fetchFavorite}
                                                fetchDeleteFiles={fetchDeleteFiles}
                                                is_read={is_read}
                                                is_viewed={is_seen}
                                                reply_to={parent_message?.[0]}
                                                currentMessageAnswer={currentMessageAnswer}
                                                setCurrentMessageAnswer={(e) => setCurrentMessageAnswer(e)}
                                                message_id={message_id}
                                                isAuthor={isAuthor}
                                                messageData={item}
                                            />
                                        </div>
                                    );
                                }))}

                            </>
                        </InfiniteScroll>

                }

            </div>

            {status2 === 'all' && <Comment
                saveFile={saveFileMessage}
                setSaveFile={setSaveFileMessage}
                type={'comments'}
                setComments={setAnswerValue}
                createFunc={onSendMessage}
                fetchDeleteFiles={fetchDeleteFiles}
                currentMessageAnswer={currentMessageAnswer}
                setCurrentMessageAnswer={(e) => setCurrentMessageAnswer(e)}
                name={currentUserName}
                email={email}
                color={currentUserColor}
                disabled={(status2 != 'all') || !chatId}
                fetchUpdateComms={resetMessages}
            />}
        </div>
    )
}

export { ChatComment }